import Pill from '../../components/Pill';

/**
 * Users-screen pill wrappers. Thin wrappers over the shared `<Pill>` primitive
 * — they exist only to lock down the label + variant so call sites stay
 * consistent across Users list + Users detail.
 *
 * Note: The admin-role pill was retired when admins were split off into their
 * own `AdminUser` collection. Player `User` rows in the admin UI no longer
 * carry an `adminRole` field.
 */

export function BannedPill({ isBanned }: { isBanned: boolean }) {
  return (
    <Pill
      variant={isBanned ? 'danger' : 'success'}
      testId={`banned-pill-${isBanned ? 'banned' : 'active'}`}
    >
      {isBanned ? 'Banned' : 'Active'}
    </Pill>
  );
}

/**
 * Live presence, from the Redis key — NOT `lastActiveAt`, which is a Mongo
 * mirror that reads "active" long after a socket dropped. Rendered for offline
 * users too: a row with no badge is ambiguous (offline? not loaded?), and this
 * column exists precisely so an operator can tell the two apart at a glance.
 */
export function OnlinePill({ isOnline }: { isOnline: boolean }) {
  return (
    <Pill
      variant={isOnline ? 'success' : 'neutral'}
      testId={`online-pill-${isOnline ? 'online' : 'offline'}`}
    >
      {isOnline ? 'Online' : 'Offline'}
    </Pill>
  );
}
